import { Grid } from '@mui/material'

import SocialEditForm from './SocialEditForm'
export default function SocialList({ path, fields, control, append, ...props }) {
  return (
    <Grid container spacing={2}>
      {fields.map((item, index) => (
        <SocialEditForm
          key={item.id}
          path={path}
          fields={fields}
          control={control}
          append={append}
          item={item}
          index={index}
          {...props}
        />
      ))}
    </Grid>
  )
}
